import { combineReducers } from "@reduxjs/toolkit";
import userFromSessionSlice from "./userFromSessionSlice";
import userSettingsSlice from "./userSettingsSlice";
import userSlice from "./userSlice";
import verifyUserEmailSlice from "./userVerifyEmailSlice";
import userDisplayNameSlice from "./userDisplayNameSlice";

export const userReducer = combineReducers({
  loggedInUser: userFromSessionSlice,
  userSettings: userSettingsSlice,
  signUpUser: userSlice,
  verifyUserEmail: verifyUserEmailSlice,
  userDisplayName: userDisplayNameSlice
});